/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { ApplicationRef, ComponentFactoryResolver, Inject, Injectable, Injector, NgZone } from '@angular/core';
import {
    Overlay,
    OverlayKeyboardDispatcher, OverlayOutsideClickDispatcher,
    OverlayPositionBuilder,
    ScrollStrategyOptions,
} from '@angular/cdk/overlay';
import { DashGisOverlayContainer } from './dash-gis-overlay-container.service';
import { DOCUMENT, Location } from '@angular/common';
import { Directionality } from '@angular/cdk/bidi';

@Injectable()
export class DashGisOverlay extends Overlay {
    private _dashGisOverlayContainer: DashGisOverlayContainer;

    constructor(
        scrollStrategies: ScrollStrategyOptions,
        _overlayContainer: DashGisOverlayContainer,
        _componentFactoryResolver: ComponentFactoryResolver,
        _positionBuilder: OverlayPositionBuilder,
        _keyboardDispatcher: OverlayKeyboardDispatcher,
        _appRef: ApplicationRef,
        _injector: Injector,
        _ngZone: NgZone,
        @Inject(DOCUMENT) _document: any,
        _directionality: Directionality,
        _location: Location,
        _outsideClickDispatcher: OverlayOutsideClickDispatcher
    ) {
        super(
            scrollStrategies,
            _overlayContainer,
            _componentFactoryResolver,
            _positionBuilder,
            _keyboardDispatcher,
            _injector,
            _ngZone,
            _document,
            _directionality,
            _location,
            _outsideClickDispatcher
        );

        this._dashGisOverlayContainer = _overlayContainer;
        this.setContainerElement(_document.querySelector('#overlayContent'));
    }

    public setContainerElement(containerElement: HTMLElement): void {
        this._dashGisOverlayContainer.setContainerElement(containerElement);
    }
}
